module.exports = __webpack_public_path__ + "static/media/logo.02ec26b4.svg";